export { SliderCard as default } from './SliderCard';
